module.exports = {
    __esModule: true,
    default: function anonymous(props
) {
var out='<div data-playable-hook="top-block" class="'+(props.styles.topBlock)+'"> <div class="'+(props.styles.background)+'" data-playable-hook="screen-top-background"> </div> <div class="'+(props.styles.elementsContainer)+'"> <div class="'+(props.styles.liveIndicatorContainer)+'" data-playable-hook="live-indicator-container"> </div> <div class="'+(props.styles.titleContainer)+'" data-playable-hook="title-container"> </div> </div></div>';return out;
} 
  };